import React, { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'

const API = process.env.REACT_APP_BACKEND_URL

const FLAG_COLORS = [
  { id: null, hex: 'transparent', label: 'Aucun', border: '#CBD5E1' },
  { id: 'jaune_fluo', hex: '#DFFF00', label: 'Jaune fluo' },
  { id: 'vert_fluo', hex: '#39FF14', label: 'Vert fluo' },
  { id: 'rose_fluo', hex: '#FF6EC7', label: 'Rose fluo' },
  { id: 'orange_fluo', hex: '#FF5F1F', label: 'Orange fluo' },
  { id: 'cyan_fluo', hex: '#00FFFF', label: 'Cyan fluo' },
  { id: 'magenta_fluo', hex: '#FF00FF', label: 'Magenta fluo' },
]

export function getFlagHex(flagId) {
  return FLAG_COLORS.find(c => c.id === flagId)?.hex || 'transparent'
}

export default function FlagAttenteCell({ sinistre, onUpdated }) {
  const [open, setOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const ref = useRef(null)
  const current = sinistre.flag_attente

  useEffect(() => {
    function handleClickOutside(e) {
      const popover = document.querySelector('[data-testid="flag-attente-popover"]')
      if (ref.current && !ref.current.contains(e.target) && (!popover || !popover.contains(e.target))) setOpen(false)
    }
    if (open) document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  async function handleSelect(flagId) {
    setSaving(true)
    try {
      const res = await fetch(`${API}/api/sinistres/${sinistre.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ flag_attente: flagId }),
      })
      if (res.ok && onUpdated) onUpdated()
    } finally {
      setSaving(false)
      setOpen(false)
    }
  }

  const hex = getFlagHex(current)

  return (
    <div className="relative" ref={ref} onClick={e => e.stopPropagation()}>
      <button
        onClick={() => setOpen(!open)}
        className="w-5 h-5 rounded border-2 transition-all hover:scale-110"
        style={{
          backgroundColor: current ? hex : 'transparent',
          borderColor: current ? hex : '#CBD5E1',
          boxShadow: current ? `0 0 8px ${hex}80` : 'none',
        }}
        title={current ? FLAG_COLORS.find(c => c.id === current)?.label : 'Marquer en attente'}
        data-testid="flag-attente-cell"
      />

      {open && createPortal(
        <div className="fixed z-[9999] bg-white rounded-lg shadow-xl border border-slate-200 p-2 flex gap-1.5"
             style={{
               top: ref.current ? ref.current.getBoundingClientRect().bottom + 4 : 0,
               left: ref.current ? Math.max(ref.current.getBoundingClientRect().left - 30, 8) : 0,
             }}
             onClick={e => e.stopPropagation()}
             data-testid="flag-attente-popover">
          {FLAG_COLORS.map(c => (
            <button
              key={c.id || 'none'}
              onClick={() => handleSelect(c.id)}
              disabled={saving}
              className={`w-7 h-7 rounded-md border-2 transition-all hover:scale-110 ${
                current === c.id ? 'ring-2 ring-offset-1 ring-slate-800' : ''
              }`}
              style={{
                backgroundColor: c.hex === 'transparent' ? 'white' : c.hex,
                borderColor: c.border || c.hex,
                boxShadow: c.hex !== 'transparent' ? `0 0 6px ${c.hex}60` : 'none',
              }}
              title={c.label}
              data-testid={`flag-color-${c.id || 'none'}`}
            />
          ))}
        </div>,
        document.body
      )}
    </div>
  )
}

export { FLAG_COLORS }
